module.exports = __webpack_public_path__ + "img/brightscreen_1000.5341d71e.png";